import React, { useCallback, useEffect, useState } from "react";
import { Box, Grid, useMediaQuery } from "@mui/material";
import { Datagrid, FunctionField, ListContextProvider, NumberField, SimpleShowLayout, TextField } from "react-admin";
import { settings } from "app";
import { graduationRequests } from "api/graduationApi";
import dataProvider from "server/dataProvider";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import RequirementsDialog from "./RequirementsDialog";
import RequirementsHistoryDialog from "./RequirementsHistoryDialog";
import RequirementAchievementDialog from "./RequirementAchievementDialog";

const Requirements = ({ record }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const [requirements, setRequirements] = useState([]);

  const fetchRequirements = useCallback(async () => {
    try {
      const { data } = await dataProvider.customRequest(
        graduationRequests.studentDisciplinesRequirements(record?.studentEducationId),
      );
      setRequirements(data);
    } catch (err) {
      console.error(err);
    }
  }, [record?.studentEducationId]);

  useEffect(() => {
    if (!record?.studentEducationId) return;
    fetchRequirements();
  }, [record?.studentEducationId, fetchRequirements]);

  return (
    <SimpleShowLayout>
      <Grid
        container
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "start",
          }}
        >
          <ListContextProvider value={{ data: requirements }}>
            <Datagrid
              rowClick={false}
              bulkActionButtons={false}
              sx={{ margin: 2, ...settings.style.secondaryDatagrid }}
            >
              <TextField
                source="disciplineNameBg"
                label="Дисциплина"
              />
              <TextField
                source="requirementNameBg"
                label="Норматив"
              />
              <TextField
                source="unitNameBg"
                label="Мерна единица"
              />
              <FunctionField
                label="Изпълнено"
                sortBy="achievedCount"
                render={rec => (
                  <NumberField
                    source="achievedCount"
                    sx={{
                      color: (rec?.achievedCount ?? 0) >= (rec?.requiredCount ?? 0) ? "success.main" : "error.main",
                    }}
                  />
                )}
              />
              <NumberField
                source="requiredCount"
                label="Изискване"
              />
              <FunctionField
                render={rec => (
                  <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                    <SecuredComponent permission={permissions.canManageInternshipStudentsDisciplineRequirements}>
                      <RequirementAchievementDialog
                        studentEducationId={record?.studentEducationId}
                        requirement={rec}
                        fetchRequirements={fetchRequirements}
                      />
                    </SecuredComponent>
                    <SecuredComponent permission={permissions.canPreviewInternshipStudentsDisciplineRequirementHistory}>
                      <RequirementsHistoryDialog
                        studentEducationId={record?.studentEducationId}
                        requirementId={rec?.requirementId}
                        planId={record?.planId}
                      />
                    </SecuredComponent>
                  </Box>
                )}
              />
            </Datagrid>
          </ListContextProvider>
          <SecuredComponent permission={permissions.canManageInternshipStudentsDisciplineRequirements}>
            <RequirementsDialog
              planId={record?.planId}
              studentEducationId={record?.studentEducationId}
              fetchRequirements={fetchRequirements}
              requirements={requirements}
            />
          </SecuredComponent>
        </Grid>
      </Grid>
    </SimpleShowLayout>
  );
};

export default Requirements;
